<template>
  <div>
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="12">
          <el-form-item label="難易程度">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題及插圖"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <el-form-item label="問題圖片">
        <upload :placeholder="formLabelAlign.img_url || '請選擇問題圖片'" @childByValue="onUploadSuccess"></upload>
        <div class="img-box" v-if="rulesForm.img_url">
          <div class="close" @click="rulesForm.img_url = ''"></div>
          <img :src="rulesForm.img_url" />
        </div>
      </el-form-item>
      <vue-dividing-line title="正確答案"></vue-dividing-line>
      <div class="required">正確答案 *</div>
      <!-- <div>選項 <span class="required">*</span></div> -->
      <el-form-item label="選項" prop="trueFlase">
        <el-radio-group v-model="rulesForm.trueFlase">
          <el-radio label="0">正確</el-radio>
          <el-radio label="1">錯誤</el-radio>
        </el-radio-group>
      </el-form-item>
      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import { symbol } from '../plugins/directive'
import rules from "../plugins/validator";
export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce, upload },
  data() {
    return {
      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],
      
      rulesForm: {},
      rules: {
        ...rules,
        trueFlase: [
          { required: true, message: '請選擇正確答案', trigger: 'change' }
        ],
      },

      units: [],
    };
  },
  methods: {
    preview() {
      let form = this.handleFromData()
      form.type = 1
      this.$emit('preview', form)
    },
    childByVideoUrl(v) {
      this.rulesForm.videoUrl = v;
      this.$forceUpdate();
    },
    onUploadSuccess(url) {
      this.rulesForm.img_url = url;
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { trueFlase } = form

      // 处理數据
      form.answers = [{value: trueFlase}]
      form.choices = [
        {value: "0"},
        {value: "1"}
      ]

      form.content = JSON.stringify({
        trueFlase
      })

      return form
    },
    // 提交
    onSubmit() {
      let form = this.handleFromData()
      // type, type_display
      this.$emit('save', form, 1, 1)
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
  },
  created() {
    this.rulesForm = {
      ...this.formLabelAlign,
      trueFlase: '0'
    }
  },
  mounted() {

    if(this.rulesForm.id) {
      let content = JSON.parse(this.rulesForm.content)
      this.rulesForm.trueFlase = content.trueFlase
    }
  }
};
</script>

<style lang="scss" scoped>
</style>